export const GOODS_PAGE = '/erp/goods/list'
export const STOCK_PAGE = '/erp/goods/stock/list'

export function hasErpPageAccess(items, routePath) {
  return (items || []).some(item => item.routePath === routePath || hasErpPageAccess(item.children, routePath))
}

// Keep the original permission tree intact. Inventory-only roles retain their entry.
export function mergeGoodsMenus(items) {
  return (items || []).map(item => {
    if (!item.children) return item
    const children = mergeGoodsMenus(item.children)
    const hasGoods = children.some(child => child.routePath === GOODS_PAGE)
    return { ...item, children: hasGoods ? children.filter(child => child.routePath !== STOCK_PAGE) : children }
  })
}
